/**
 * InspectionNotesSection - "Inspection Notes" form section molecule.
 *
 * Renders the framed section card that owns the inspection-only general
 * notes textarea. Used by the JobFormTemplate when formType is
 * 'inspection'. Recommendations and follow-up notes are captured later
 * on the inspection detail page (after the inspector reviews the site)
 * so they aren't included here.
 */
import React from 'react';
import { SectionCard } from '../SectionCard';

/* ============================================
 * TYPE DEFINITIONS
 * ============================================ */

export interface InspectionNotesSectionProps {
	generalNotes: string;
	onGeneralNotesChange: (value: string) => void;
	/** Standard styling tokens. */
	labelClass: string;
	normalBorder: string;
	/** Optional extra classes for the outer wrapper. */
	className?: string;
}

/* ============================================
 * COMPONENT
 * ============================================ */

export const InspectionNotesSection: React.FC<InspectionNotesSectionProps> = ({
	generalNotes,
	onGeneralNotesChange,
	labelClass,
	normalBorder,
	className = '',
}) => {
	return (
		<SectionCard title="Inspection Notes" className={`inspection-notes-section ${className}`} dataRef="molecule-inspection-notes-section">
			<div className="inspection-notes-section__body">
				<label htmlFor="generalNotes" className={labelClass}>General Notes</label>
				<textarea id="generalNotes" value={generalNotes} onChange={(e) => onGeneralNotesChange(e.target.value)} rows={4} className={`block w-full rounded-md border px-12px py-10px text-16px font-sans focus:outline-none focus:ring-2 ${normalBorder}`} placeholder="Any initial observations or notes..." />
			</div>
		</SectionCard>
	);
};

export default InspectionNotesSection;
